export const MAX_SUGGESTIONS = 10
export const MAX_NAVIGATIONAL_SUGGESTIONS = 1
export const SEARCH_BAR_HEIGHT_PX = '48px'
export const ICON_SIZE_PX = '24px'
export const LIST_ICON_SIZE_PX = '20px'
export const CLEAR_BUTTON_SIZE_MOBILE_PX = '44px'
export const CLEAR_BUTTON_SIZE_DESKTOP_PX = '36px'
export const SKELETON_LIST_ITEM_HEIGHT_PX = '28px'
